module.exports = __webpack_public_path__ + "static/img/group.86a202b.png";


//////////////////
// WEBPACK FOOTER
// ./public/hadoopImg/group.png
// module id = yj9B
// module chunks = 0